import { Component, inject } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatDialogRef } from "@angular/material/dialog";
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";

@Component({
  selector: "postgenie-regenerate-dialog",
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  templateUrl: "./regenerate-dialog.component.html",
  styleUrls: ["./regenerate-dialog.component.scss"],
})
export class RegenerateDialogComponent {
  dialog = inject(MatDialogRef);

  workflowForm: FormGroup = new FormGroup({
    postTone: new FormControl("", [Validators.required]),
  });

  public postTones = [
    {
      key: "Creative",
      value: "Creative",
    },
    {
      key: "Serious",
      value: "Serious",
    },
    {
      key: "Inspirational",
      value: "Inspirational",
    },
    {
      key: "Professional",
      value: "Professional",
    },
    {
      key: "Engaging",
      value: "Engaging",
    },
  ];

  regenerate(): void {
    this.dialog.close(this.workflowForm.value.postTone);
  }

  setPostTone(postTone): void {
    this.workflowForm.patchValue({
      postTone: postTone,
    });
  }
}
